/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS201: Simplify complex destructure assignments
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const dependencies = [
  '$q', '$scope', 'Employee', 'DayOff', 'ShiftEmployeeActionsService', 'SickDay',
  'bookingShiftEmployeeAvailability', 'cableService', 'bookingShiftEmployeeAssignStatus',
  'dateService', 'confirmService', 'employeeStatus', 'employeeDayOffRequestStatus', 'employeeSickDayRequestStatus',
  'notificationService', 'currentUserService'
];

const PopupBookingShiftFormEmployeesBidController = function(
  $q, $scope, Employee, DayOff, ShiftEmployeeActionsService, SickDay,
  bookingShiftEmployeeAvailability, cableService, bookingShiftEmployeeAssignStatus,
  dateService, confirmService, employeeStatus, employeeDayOffRequestStatus, employeeSickDayRequestStatus,
  notificationService, currentUserService
) {

  const vm = this;

  vm.shiftEmployeeAvailability = bookingShiftEmployeeAvailability;
  vm.filteredEmployees = [];
  vm.timeLineLoader = $scope.timeLineLoader;
  vm.isShiftBid = true;
  vm.isShiftInFuture = new Date($scope.shift.endTime) > Date.now();
  vm.isChangingBid = false;
  vm.hasInvitedEmployees = false;

  vm.$onInit = function() {
    initActionsService();
    subscribeToBookingTimeline();
    loadEmployees();
  };

  const getShiftId = () => $scope.shiftEmployeeManager.options.params.shiftId;
  const getBookingId = () => $scope.shiftEmployeeManager.options.params.bookingId;

  vm.canInviteEmployees = () => $scope.editable && !currentUserService.isClientManagerLogged();

  vm.getResourceRolesText = function () {
    return _.map(vm.shift.resource.roles, 'name').join(', ');
  };

  const updateShiftEmployeeAfterSuccessStatusChange = function(employee, updatedShiftEmployee) {
    $scope.shiftEmployeeManager.updateEntity(updatedShiftEmployee);
    if (updatedShiftEmployee.splitForId) { updateSplitShifts(updatedShiftEmployee); }
    return prepareEmployee(employee, updatedShiftEmployee);
  };

  const setEmployeeStatusForSplit = function(employee, splitShiftEmployee, updateDataCb) {
    splitShiftEmployee.employeeId = employee.id;
    return updateDataCb(employee, splitShiftEmployee).then(function() {
      $scope.assignForShiftEmployee = undefined;
      return $scope.backCb();
    });
  };

  const assignForSplit = (employee, splitShiftEmployee) => {
    return setEmployeeStatusForSplit(employee, splitShiftEmployee, assignExisting);
  };

  const assignExisting = (employee, existingShiftEmployee) => {
    return vm.actionsService.assign(existingShiftEmployee).then(updatedShiftEmployee => {
      updateShiftEmployeeAfterSuccessStatusChange(employee, updatedShiftEmployee);
      if ($scope.isShiftIssueInviteEmployee) {
        notificationService.notifySuccess('Shift issue resolved');
        if ($scope.onClose) { $scope.onClose(); }
      }
    }).catch(() => loadEmployees());
  };

  const assignNew = employee => {
    return vm.actionsService.assign(null, getBookingId(), getShiftId(), employee.id).then(updatedShiftEmployee => {
      updateShiftEmployeeAfterSuccessStatusChange(employee, updatedShiftEmployee);
      if ($scope.isShiftIssueInviteEmployee) {
        notificationService.notifySuccess('Shift issue resolved');
        if ($scope.onClose) { $scope.onClose(); }
      }
    }).catch(() => loadEmployees());
  };

  const assign = function(employee) {
    let existingShiftEmployee;
    vm.isChangingBid = false;
    if (!(canBeInvited(employee) || hasStatus(employee, bookingShiftEmployeeAssignStatus.getNewStatus()))) { return; }
    if ($scope.assignForShiftEmployee) {
      return assignForSplit(employee, $scope.assignForShiftEmployee);
    } else if (!employee.isSubContractor && (existingShiftEmployee = findShiftEmployee($scope.shiftEmployeeManager, employee))) {
      return assignExisting(employee, existingShiftEmployee);
    } else {
      return assignNew(employee);
    }
  };

  const inviteForSplit = (employee, splitShiftEmployee) => {
    return setEmployeeStatusForSplit(employee, splitShiftEmployee, inviteExisting);
  };

  const inviteExisting = (employee, existingShiftEmployee) => {
    return vm.actionsService.invite(existingShiftEmployee).then(updatedShiftEmployee => {
      return updateShiftEmployeeAfterSuccessStatusChange(employee, updatedShiftEmployee);
    }).catch((error) => {
      if(error.data && error.data.error){
        notificationService.notifySuccess(error.data.error);
      }
      loadEmployees()
    });
  };

  const inviteNew = employee => {
    return vm.actionsService.invite(null, getBookingId(), getShiftId(), employee.id).then(updatedShiftEmployee => {
      return updateShiftEmployeeAfterSuccessStatusChange(employee, updatedShiftEmployee);
    }).catch((error) => {
      if(error.data && error.data.error){
        notificationService.notifySuccess(error.data.error);
      }
      loadEmployees()
    });
  };

  const invite = function(employee) {
    let existingShiftEmployee;
    if (!canBeInvited(employee)) { return; }
    if ($scope.assignForShiftEmployee) {
      return inviteForSplit(employee, $scope.assignForShiftEmployee);
    } else if ((existingShiftEmployee = findShiftEmployee($scope.shiftEmployeeManager, employee))) {
      return inviteExisting(employee, existingShiftEmployee);
    } else {
      return inviteNew(employee);
    }
  };

  const blowOut = employee => {
    const shiftEmployee = findShiftEmployee($scope.shiftEmployeeManager, employee);
    if (!shiftEmployee) { return; }
    return vm.actionsService.blowOut(shiftEmployee, employee.id).then(updatedShiftEmployee => {
      return updateShiftEmployeeAfterSuccessStatusChange(employee, updatedShiftEmployee);
    }).catch(() => loadEmployees());
  };
  
  const declineInvitationOrUnassign = function(employee, confirmationText, conflictedShiftEmployee) {
    let existingShiftEmployee;
    vm.isChangingBid = false;
    if (!conflictedShiftEmployee) {
      existingShiftEmployee = findShiftEmployee($scope.shiftEmployeeManager, employee);
    }
    if (!conflictedShiftEmployee && !existingShiftEmployee) { return; }

    return confirmService.confirm(confirmationText[0], confirmationText[1], confirmationText[2], () => {
      return vm.actionsService.unassign(conflictedShiftEmployee || existingShiftEmployee).then(function() {
        employee.availabilityStatus = bookingShiftEmployeeAssignStatus.getNotAssignedStatus();
        if (existingShiftEmployee) { $scope.shiftEmployeeManager._removeEntity(existingShiftEmployee); }
        if (conflictedShiftEmployee) { $scope.conflictedShiftEmployeeManager._removeEntity(conflictedShiftEmployee); }
      }).catch(() => loadEmployees());
    });
  };

  const declineInvitation = employee => {
    return declineInvitationOrUnassign(
      employee, ['Confirm cancelling bid', 'Do you want to cancel the bid for this employee?', 'Yes']
    );
  };

  const unassign = employee => {
    return declineInvitationOrUnassign(employee, ['Confirm unassign', 'Do you want to unassign this employee?', 'Yes']);
  };

  vm.allowChangeEmployee = () => {
    vm.isChangingBid = true;
    vm.filterEmployees();
  }

  vm.getAssignedCount = () => {
    return _.filter($scope.shiftEmployeeManager.entities, shiftEmployee => {
      return bookingShiftEmployeeAssignStatus.countsAsAssigned(shiftEmployee.assignStatus);
    }).length;
  };

  vm.getAssignedEmployees = () => {
    return _.filter(vm.employees, employee => hasStatus(employee, bookingShiftEmployeeAssignStatus.getAssignedStatus()));
    if(assignedEmployees && assignedEmployees.length > 0 && assignedEmployees[0].user.thumbAvatar.url) {
      return assignedEmployees;
    }
    return [];
  };

  vm.getAssignedUserImage = (assignedEmployee) => {
    if(assignedEmployee.user.thumbAvatar.url) {
      return assignedEmployee.user.thumbAvatar.url;
    }
    return "/images/empty-client-list.svg";
  };
  vm.getAssignedUserImageClass = (assignedEmployee) => {
    if(assignedEmployee.user.thumbAvatar.url) {
      return "rounded";
    }
    return "";
  };

  vm.getConflictedShifts = employee => {
    return _.filter($scope.conflictedShiftEmployeeManager.entities, shiftEmployee => {
      return shiftEmployee.employeeId === employee.id;
    });
  };

  vm.getOvertime = function(shiftEmployee) {
    const maxStartDate = dateService.getMax(vm.shift.startTime, shiftEmployee.startTime, dateService.getIsoFullDateFormat());
    const minEndDate = dateService.getMin(vm.shift.endTime, shiftEmployee.endTime, dateService.getIsoFullDateFormat());
    return Math.ceil(minEndDate.diff(maxStartDate, 'hours', true));
  };

  vm.getNotPassedLicensesText = employee => _.map(employee.notPassedLicensesForResource, 'name').join(', ');

  vm.isShownActionDropdown = function (employee) {
    if (vm.shift.resource.roles.length > 0) {
      return _.intersectionBy(employee.roles, vm.shift.resource.roles, 'id').length > 0;
    } else {
      return true;
    }
  };

  const filterByInvited = employees => _.filter(employees, employee => hasStatus(employee, bookingShiftEmployeeAssignStatus.getNewStatus()));
  const filterByAssigned = employees => _.filter(employees, employee => hasStatus(employee, bookingShiftEmployeeAssignStatus.getAssignedStatus()));
  const filterByAssignedOrInvited = employees => _.filter(employees, employee => 
    hasStatus(employee, bookingShiftEmployeeAssignStatus.getAssignedStatus()) || hasStatus(employee, bookingShiftEmployeeAssignStatus.getNewStatus())
  );

  const filterByName = function(employees, employeeName) {
    if (!employeeName) { return employees; }
    return _.filter(employees, employee => employee.fullNameLower.indexOf(employeeName.toLowerCase()) !== -1);
  };

  vm.filterEmployees = function(queryParams) {
    sortEmployees();
    const assignedCount = vm.getAssignedCount();
    if(assignedCount > 0 && assignedCount < vm.shift.requiredEmployeesCount) {
      return vm.filteredEmployees = filterByName(filterByAssignedOrInvited(vm.employees), vm.employeeName);
    }
    else if(vm.isChangingBid) {
      return vm.filteredEmployees = filterByName(filterByAssigned(vm.employees), vm.employeeName);
    }
    else {
      return vm.filteredEmployees = filterByName(filterByInvited(vm.employees), vm.employeeName);
    }
  };

  const hasStatus = (employee, status) => employee.availabilityStatus === status;

  const canBeInvited = employee => {
    return !employee.isBannedForClient && (employee.isSubContractor || bookingShiftEmployeeAssignStatus.canBeInvited(employee.availabilityStatus));
  };

  const sortEmployees = () => {
    return vm.employees = _.sortBy(_.sortBy(vm.employees, ['fullNameLower']), employee => {
      return bookingShiftEmployeeAssignStatus.sortPositionOf(employee.availabilityStatus);
    });
  };

  const prepareEmployee = function(employee, shiftEmployee, dayOff, sickDay) {
    if (employee.isBannedForClient) {
      employee.availabilityStatus = bookingShiftEmployeeAssignStatus.getBannedForClientStatus();
    } else if (dayOff) {
      employee.availabilityStatus = bookingShiftEmployeeAssignStatus.getInDayOffStatus();
    } else if (sickDay) {
      employee.availabilityStatus = bookingShiftEmployeeAssignStatus.getInSickDayStatus();
    } else if (shiftEmployee && !$scope.assignForShiftEmployee) {
      employee.availabilityStatus = shiftEmployee.assignStatus;
    } else if (employee.availabilities.length > 0) {
      employee.availabilityStatus = bookingShiftEmployeeAssignStatus.getInAvailabilityStatus();
    } else {
      employee.availabilityStatus = bookingShiftEmployeeAssignStatus.getNotAssignedStatus();
    }
    return true;
  };

  const prepareEmployees = (employees, dayOffs, sickDays) => {
    return _.each(employees, function (employee) {
      employee.fullName = employee.getFullName();
      employee.fullNameLower = employee.fullName.toLowerCase();
      employee.notPassedLicensesForResource = getNotPassedLicensesForResource(employee.passedLicenses);
      const shiftEmployee = findShiftEmployee($scope.shiftEmployeeManager, employee);
      const foundDayOff = _.find(dayOffs, dayOff => dayOff.employeeId === employee.id);
      const foundSickDay = _.find(sickDays, sickDay => sickDay.employeeId === employee.id);
      return prepareEmployee(employee, shiftEmployee, foundDayOff, foundSickDay);
    });
  };

  const getNotPassedLicensesForResource = function (passedLicenses) {
    return _.differenceWith(
      $scope.shift.resource.trainings,
      passedLicenses,
      (resourceTraining, passedLicense) => {
        return resourceTraining.id === passedLicense.trainingId;
      }
    );
  };

  const updateSplitShifts = shiftEmployee => {
    return _.each($scope.shiftEmployeeManager.entities, function (existingShiftEmployee) {
      if (existingShiftEmployee.id === shiftEmployee.splitForId) {
        const foundSplitShift = _.find(existingShiftEmployee.splitShifts, splitShift => {
          return splitShift.id === shiftEmployee.id;
        });
        if (foundSplitShift && !_.isEqual(shiftEmployee, foundSplitShift)) {
          angular.copy(shiftEmployee, foundSplitShift);
        }
        return false;
      }
    });
  };

  const findShiftEmployee = (entityManager, employee) => {
    return _.find(entityManager.entities, shiftEmployee => shiftEmployee.employeeId === employee.id);
  };

  const loadEmployees = () => {
    return $scope.conflictedShiftEmployeeManager.loadAll().then(function () {
      _.each($scope.conflictedShiftEmployeeManager.entities, conflictedShiftEmployee => {
        _.each(conflictedShiftEmployee.splitShifts, splitShift => {
          splitShift.shift = conflictedShiftEmployee.shift;
        });
      });
      const promises = [
        Employee.query({
          resourceId: $scope.shift.resource.id,
          clientId: $scope.clientId,
          status: employeeStatus.getActiveStatus(),
          from: $scope.shift.startTime,
          to: $scope.shift.endTime
        }),
        DayOff.query({
          from: $scope.shift.startTime,
          to: $scope.shift.endTime,
          status: employeeDayOffRequestStatus.getApprovedStatus()
        }),
        SickDay.query({
          from: $scope.shift.startTime,
          to: $scope.shift.endTime,
          status: employeeSickDayRequestStatus.getApprovedStatus()
        })
      ];
      return $q.all(promises).then(function (...args) {
        const [employees, dayOffs, sickDays] = Array.from(args[0]);
        vm.employees = prepareEmployees(employees, dayOffs, sickDays);
        const allInvitedEmployees = filterByName(filterByInvited(vm.employees), "");
        vm.hasInvitedEmployees = allInvitedEmployees && allInvitedEmployees.length > 0;
        vm.actionsService.setEmployees(vm.employees);
        return vm.filterEmployees();
      });
    });
  };

  const checkedReloadEmployees = function(data) {
    if ($scope.shift.id === data.shift_id) { return loadEmployees(); }
  };

  const checkedReloadEmployeesAfterEventChange = function(event) {
    if (!(event.start_time >= $scope.shift.endTime) && !(event.end_time <= $scope.shift.startTime)) {
      return loadEmployees();
    }
  };

  const subscribeToBookingTimeline = function() {
    const bookingTimelineChannel = cableService.getBookingTimelineChannel();
    if (bookingTimelineChannel) {
      for (let cableUpdateEvent of ['shift_employee', 'shift_employee_destroyed']) {
        bookingTimelineChannel.addCallbackWithCleanup($scope, cableUpdateEvent, checkedReloadEmployees);
      }
      for (let cableUpdateEvent of ['day_off', 'day_off_destroyed', 'sick_day', 'sick_day_destroyed']) {
        bookingTimelineChannel.addCallbackWithCleanup($scope, cableUpdateEvent, checkedReloadEmployeesAfterEventChange);
      }
    }
  };

  const initActionsService = function() {
    vm.actionsService = new ShiftEmployeeActionsService;
    if ($scope.assignForShiftEmployee) {
      vm.actionsService.isSplitShift();
    }
    //vm.actionsService.setShiftBid(true);
    vm.actionsService.on('invite', invite);
    vm.actionsService.on('declineInvitation', declineInvitation);
    vm.actionsService.on('assign', assign);
    vm.actionsService.on('unassign', unassign);
    vm.actionsService.on('blowOut', blowOut);

  };

  $scope.$watch('shift', function() {
    vm.shift = angular.copy($scope.shift);
    vm.shift.isShiftBid = vm.isShiftBid
    return vm.actionsService.setShifts(vm.shift);
  });

  return vm;

};

angular.module('popup.booking').controller('PopupBookingShiftFormEmployeesBidController',
  dependencies.concat(PopupBookingShiftFormEmployeesBidController));
